module.exports = __webpack_public_path__ + "img/md-pwd.svg";